import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-dropdown-menu-dropdown',
  imports: [],
  templateUrl: './dropdown-menu-dropdown.component.html',
  styleUrl: './dropdown-menu-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuDropdownComponent {}
